var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Slider home-slider"},[_c('b-carousel',{staticStyle:{"text-shadow":"1px 1px 2px #333"},attrs:{"id":"carousel-1","interval":4000,"indicators":false,"background":"#fff","img-width":"100%","img-height":"480"}},[_c('b-carousel-slide',{attrs:{"img-src":_vm.banner1}}),_c('b-carousel-slide',{attrs:{"img-src":_vm.banner3}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }